import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";


import routes from "./config";
import GlobalStyles from "../globalStyles";
import Services from "../components/Services";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <GlobalStyles />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <div>
            {/* <Header /> */}

            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
            {/* <Footer /> */}
            </div>

          );
        })}
      </Switch>

      <Route key="services" path="/services" component={Services} />

    </Suspense>
  );
};

export default Router;
